import moment from 'moment';

export default class DateTools {
    static isoWeekYear(date) {
        const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        d.setUTCDate(d.getUTCDate() + 3 - ((d.getUTCDay() + 6) % 7));
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
        const weekNo = 1 + Math.round(((d - yearStart) / 86400000 - 3 + ((yearStart.getUTCDay() + 6) % 7)) / 7);
        return { week: weekNo, year: d.getUTCFullYear() };
    }

    static getWeekDays(date){
        const tmp = new Date(date);
        const day = tmp.getDay();
        const monday = new Date(tmp.setDate(tmp.getDate() - ((day + 6) % 7)));
        return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(monday);
        d.setDate(monday.getDate() + i);
        return moment(d).format('YYYY-MM-DD');
        });
    }

    static getWeekdayName(dateInput, locale = 'en-US') {
        const date = new Date(dateInput)
        if (isNaN(date)) return ''
        return new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date)
    }
}